import { CreateActionParams } from '../actions';
import { bookingsBookingsFormLoad } from '@wix/bi-logger-wixboost-ugc/v2';
import { FormStatus } from '../../../../types/form-state';
import { ReferralInfo } from '../../../../types/biLoggerTypes';
import { FormState } from '../../../../utils/state/types';
import { createInitialState } from '../../../../utils/state/initialStateFactory';

export type InitializeWidget = () => void;

export function createInitializeWidgetAction({
  flowApi,
  getControllerState,
  internalActions: { calculatePaymentDetails },
  context: {
    biLogger,
    formApi,
    reportError,
    wixSdkAdapter,
    t,
    bookingsDataCapsule,
  },
}: CreateActionParams): InitializeWidget {
  return async () => {
    const [state, setState] = getControllerState();

    try {
      const initialState: FormState = await createInitialState({
        currentState: state,
        wixSdkAdapter,
        bookingsDataCapsule,
        flowApi,
        formApi,
        t,
        reportError,
      });
      const { isCart, isServiceInCart, serviceData } = initialState;

      if (initialState?.errors?.length) {
        console.error(initialState.errors[0]);
      }

      setState({
        ...initialState,
      });

      biLogger?.initialDefaultBiLogger(initialState);

      biLogger?.report(
        bookingsBookingsFormLoad({
          formId: serviceData.formSchema.formId,
          ...(isCart
            ? {
                ...(isServiceInCart
                  ? { referralInfo: ReferralInfo.AddMoreSessions }
                  : {}),
                emptyCart: !isServiceInCart,
              }
            : {}),
          numberOfServices: Object.keys(serviceData.slotServices).length,
        }),
      );

      setState({
        status: FormStatus.IDLE,
      });

      await calculatePaymentDetails({});

      const existingBooking = await formApi.getExistingBooking({
        slotServices: initialState.serviceData.slotServices,
        contactId: flowApi?.controllerConfig?.wixCodeApi?.user?.currentUser?.id,
      });

      if (existingBooking) {
        setState({
          existingBookingDetails: existingBooking,
        });
      }
    } catch (e) {
      console.error(e);
      setState({
        status: FormStatus.IDLE,
      });
    }
  };
}
